export default [
  {
    id: 'labor',
    title: 'Наследственные споры',
    services: [
      'оспаривание завещания, договора ренты или дарственнойя',
      'оспаривание наследства в суде, оспаривание долей',
      'восстановление срока принятия наследства',
      'признание наследника недостойным',
      'оспаривание действий нотариуса',
      'раздел наследуемого имущества',
      'взыскание долгов наследодателя с наследника',
      'выделение супружеской доли в наследстве',
      'подготовка документов для оспаривания наследства',
      'признание сделки с наследуемым имуществом недействительной',
      'Подтверждение родственных связей с умершим наследодателем через суд',
    ],
  },

  {
    id: 'family',
    title: 'Семейные споры',
    services: [
      'расторжение брака',
      'раздел имущества',
      'раздел долгов и кредитов супругов',
      'взыскание алиментов на детей',
      'установление порядка общения с ребенком',
      'взыскание алиментов на родителей',
      'установление отцовства',
      'оспаривание отцовства',
      'лишение родительских прав',
      'признание брака недействительным',
      'расторжение брачного договора',
      'усыновление, удочерение',
      'установление места жительства ребенка',
    ],
  },
  {
    id: 'insurance',
    title: 'Экономические споры',
    services: [
      'взыскания денежные средств в физических и юридических лиц',
      'взыскание за не качественную оказанную услугу',
      `взыскание денежных средств за не оказанную услугу`,
      '⁠взыскание неустойки по ДДУ',
      '⁠споры с государствами органами',
      '⁠взыскание денежных средств субсидиарной ответственности',
    ],
  },
  {
    id: 'housing',
    title: 'Жилищные споры',
    services: [
      'правовая помощь при заливе квартиры',
      'споры с застройщиками',
      'нарушение сроков сдачи дома',
      'выселение и снятие регистрационного учета',
      'признание права собственности на жилое помещение',
      'установление порядка пользования квартирой',
      'истребование квартиры, дома из незаконного владения',
      `раздел лицевых счетов`,
      'о взыскании неосновательного обогащения в виде переплаты за жилищно-коммунальные услуги',
      `об исключении платежей из платежных документов`,
      `о взыскании процентов за пользование чужими денежными средствами`,
      'о перерасчете начислений',
      'о признании недействительным решения общего собрания собственников помещений',
      'о взыскании задолженности по платежам на содержание и ремонт общего имущества',
      'о признании права собственности на жилое помещение в измененном виде',
    ],
  },
];
